// src/components/formalities/FormalitiesTemplates.jsx
import React, { useEffect, useState } from "react";
import API from "api";
import { formatPrice } from "utils";
import { FiArrowLeft, FiInfo } from "react-icons/fi";
import FormalitiesTemplateItem from "./helpers/FormalitiesTemplateItem";
import FormalityPricingDetailsModal from './modals/FormalityPricingDetailsModal';
import "./assets/formalities-categories.css";
export default function FormalitiesTemplates({
  catId,
  onSelectTemplate,
  onBack,
}) {
  const assetsPath =
    "https://formalites.fortium.fr/msmedias/.formalities/assets";
  const [templates, setTemplates] = useState([]);
  const [loadingTemplates, setLoadingTemplates] = useState(false);
  const [pricingDetails, setPricingDetails] = useState(null);
  /* ===============================
     Chargement catégorie
     =============================== */
  useEffect(() => {
    loadTemplates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catId]);
  /* ===============================
     Chargement templates
     =============================== */
  const loadTemplates = async () => {
    try {
      setLoadingTemplates(true);
      const res = await API.get(
        `/formalities/categories/${catId}/templates`
      );
      setTemplates(res.data || null);
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingTemplates(false)
    }
  };

  /* ===============================
     RENDER
     =============================== */
  return (
    <div>
      {/* ===============================
         HEADER CATÉGORIE
         =============================== */}
      {/* ===============================
         LISTE DES TEMPLATES
         =============================== */}
      {!loadingTemplates && templates.length === 0 && (
        <div className="text-muted text-center">
          Aucune formalité disponible dans cette catégorie.
        </div>
      )}
      {!loadingTemplates && templates.length > 0 && (
        <div className="row g-4">
          {templates.map((tpl) => (
            <FormalitiesTemplateItem
              key={tpl.ftId}
              tpl={tpl}
              onSelect={onSelectTemplate}
              onShowPricing={setPricingDetails}
            />
          ))}
        </div>
      )}

      {/* ===============================
         RETOUR
         =============================== */}
      <div className="text-start mt-5">
        <button
          type="button"
          className="btn btn-link px-0 mt-5 d-flex align-items-center gap-2"
          onClick={onBack}
        >
          <FiArrowLeft size={18} />
          <span>Retour aux catégories</span>
        </button>
      </div>


      {pricingDetails && (
        <FormalityPricingDetailsModal
          pricing={pricingDetails}
          onClose={() => setPricingDetails(null)}
        />
      )}


    </div>
  );
}
